import { Row, Col, Tooltip } from "antd";
import { 
    PlusOutlined, 
    SaveOutlined, 
    EyeOutlined, 
    EyeInvisibleOutlined 
} from "@ant-design/icons";
import { ButtonItem, FormItem, InputItem } from "./Items"; 
/**
 * 
 * @param {*} mostrarControles Muestra los controles según una condición
 * @param {*} modoEdicion SI se esta editando algún paquete
 * @param {*} paqueteEditadoId Id del paquete que se esta editando
 * @param {*} nombrePaquete Nombre del paquete 
 * @param {*} setNombrePaquete función para guardar el nombre del paquete
 * @param {*} onGuardar funcion para guardar un paquete 
 * @param {*} onCancelar funcion para cancelar la edición/creacion de un paquete
 * @param {*} onAgregarNuevo funcion para activar el estado de agregar nuevo
 * @param {*} hayPaquetesCreados Bandera para ver si hay paquetes creados
 * @param {*} onToggleGlobalPdf Funcion para activar y desativar los pdf
 * @returns 
 */
const PaqueteControls = ({
    mostrarControles,       
    modoEdicion,            
    paqueteEditadoId,       
    nombrePaquete,          
    setNombrePaquete,       
    onGuardar,              
    onCancelar,             
    onAgregarNuevo,         
    hayPaquetesCreados,     
    onToggleGlobalPdf,
    configuracionPaquetes
}) => {
    const visible = modoEdicion || (configuracionPaquetes && mostrarControles);

    if (!visible) return null;
    return (
        <Row gutter={[16, 16]} align="middle" wrap={false} style={{ marginBottom: 15 }}>
            {modoEdicion ? (
                <>
                    <Col xs={24} sm={16} md={13} lg={15} xl={15}>
                        <FormItem label="Nombre:" required style={{ marginBottom: 0 }}>
                            <InputItem
                                placeholder="Nombre del paquete"
                                value={nombrePaquete}
                                onChange={(e) => setNombrePaquete(e.target.value)}
                            />
                        </FormItem>
                    </Col>
                    <Col>
                        <div style={{ display: 'flex', gap: 10}}>
                            <ButtonItem type="primary" cyan onClick={onGuardar}>
                                <SaveOutlined /> {paqueteEditadoId ? "Actualizar" : "Guardar"}
                            </ButtonItem>
                            <ButtonItem type="default" danger onClick={onCancelar}>
                                Cancelar
                            </ButtonItem>
                        </div>
                    </Col>
                </>
            ) : (
                <Col flex="auto">
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <ButtonItem type="primary" hotkey="alt+n" petroleo onClick={onAgregarNuevo}>
                            <PlusOutlined /> Agregar Nuevo Paquete
                        </ButtonItem>

                        {hayPaquetesCreados && (
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginLeft: 15 }}>
                                <span style={{fontSize: 12, color: '#888'}}>PDF:</span>
                                <Tooltip title="Mostrar desglose en PDF para todos">
                                    <EyeOutlined
                                        style={{ fontSize: 18, color: "green", cursor: "pointer" }}
                                        onClick={() => onToggleGlobalPdf(true)}
                                    />
                                </Tooltip>
                                <Tooltip title="Ocultar desglose en PDF (solo totales)">
                                    <EyeInvisibleOutlined
                                        style={{ fontSize: 18, color: "red", cursor: "pointer" }}
                                        onClick={() => onToggleGlobalPdf(false)}
                                    />
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </Col>
            )}
        </Row>
    );
};

export default PaqueteControls;